import { render, staticRenderFns } from "./RsaConfigurazioneParametriVitaliModalEditComponent.vue?vue&type=template&id=3d3c5fac"
import script from "./RsaConfigurazioneParametriVitaliModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneParametriVitaliModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports